<template>
  <div class="search" :lang="$i18n.locale">
    <el-tabs v-if="userName !== 'overseas'" v-model="activeName" type="card" class="searchMain" :lang="$i18n.locale" @tab-click="handleClick">
      <el-tab-pane label="VIN" name="first" class="searchInput">
        <i class="el-icon-search" />
        <el-select v-model="form.vin" filterable remote :remote-method="handleVinChange" class="vinInputW" clearable :placeholder="getPlaceholder()" @focus="onFocus">
          <el-option
            v-for="item in restaurants"
            :key="item"
            :label="item"
            :value="item"
          />
        </el-select>
        <el-button type="primary" @click="getVehicle">{{ $t('common.commonSearch') }}</el-button>
        <el-button type="primary" @click="copy(form.vin)">{{ $t('common.commonCopy') }}</el-button>
        <el-button plain @click="reset">{{ $t('table.reset') }}</el-button>
      </el-tab-pane>
      <el-tab-pane :label="$t('searchHome.vehicle')" class="searchCar" name="third">
        <ul>
          <li>
            <span><b>*</b>{{ $t('routeSearchParts.searchParts15') }}</span>
            <el-select v-model="listQuery.vehSeries" clearable :placeholder="$t('searchHome.tips')" @focus="getfocus">
              <el-option
                v-for="item in vehSeriesList"
                :key="item"
                :label="item"
                :value="item"
              />
            </el-select>
          </li>
          <li>
            <span><b>*</b>{{ $t('routeSearchParts.searchParts16') }}</span>
            <el-select v-model="listQuery.vehYearModel" clearable :placeholder="$t('searchHome.tips')" @focus="getfocus" @change="handleChange">
              <el-option
                v-for="item in vehYearModelList"
                :key="item"
                :label="item"
                :value="item"
              />
            </el-select>
          </li>
          <li>
            <span><b>*</b>{{ $t('routeSearchParts.searchParts20') }}</span>
            <el-select v-model="listQuery.optRange" :placeholder="$t('searchHome.tips')" clearable @focus="getfocus">
              <el-option
                v-for="item in optRangeList"
                :key="item"
                :label="item"
                :value="item"
              />
            </el-select>
          </li>
          <li>
            <span><b>*</b>{{ $t('routeSearchParts.searchParts17') }}</span>
            <el-select v-model="listQuery.optPower" :placeholder="$t('searchHome.tips')" clearable @focus="getfocus">
              <el-option
                v-for="item in optPowerList"
                :key="item"
                :label="item"
                :value="item"
              />
            </el-select>
          </li>
          <li>
            <span><b>*</b>{{ $t('routeSearchParts.searchParts19') }}</span>
            <el-select v-model="listQuery.batteryCore" :placeholder="$t('searchHome.tips')" clearable @focus="getfocus">
              <el-option
                v-for="item in batteryCoreList1"
                :key="item"
                :label="item"
                :value="item"
              />
            </el-select>
          </li>
          <li>
            <span>{{ $t('routeSearchParts.searchParts18') }}</span>
            <el-select v-model="listQuery.optPkg" :placeholder="$t('searchHome.tips')" clearable @focus="getfocus">
              <el-option
                v-for="item in optPkgList1"
                :key="item"
                :label="item"
                :value="item"
              />
            </el-select>
          </li>
          <li>
            <el-button plain type="primary" @click="getVehicleMaterial">{{ $t('common.commonConfirm') }}</el-button>
            <el-button plain @click="reset">{{ $t('table.reset') }}</el-button>
          </li>
        </ul>
      </el-tab-pane>
      <el-tab-pane :label="$t('searchHome.parts')" name="second">
        <ul class="searchPartsW">
          <li>
            <span>{{ $t('searchHome.part1') }}</span>
            <el-input v-model="formData.partCode" :placeholder="$t('searchHome.tips2')" clearable @clear="handleClear" />
          </li>
          <li>
            <span>{{ $t('searchHome.part2') }}</span>
            <el-input v-model="formData.partName" :placeholder="$t('searchHome.tips2')" clearable @clear="handleClear" />
          </li>
          <li>
            <span>{{ $t('routeSearchParts.searchParts15') }}</span>
            <el-select v-model="formData.vehSeries" clearable placeholder="请选择" @focus="getfocus" @clear="handleClear">
              <el-option
                v-for="item in vehSeriesList"
                :key="item"
                :label="item"
                :value="item"
              />
            </el-select>
          </li>
          <li>
            <span>{{ $t('routeSearchParts.searchParts16') }}</span>
            <el-select v-model="formData.vehYearModel" clearable placeholder="请选择" @focus="getfocus" @clear="handleClear">
              <el-option
                v-for="item in vehYearModelList"
                :key="item"
                :label="item"
                :value="item"
              />
            </el-select>
          </li>
          <li>
            <span>{{ $t('routeSearchParts.searchParts17') }}</span>
            <el-select v-model="formData.optPower" clearable placeholder="请选择" @focus="getfocus" @clear="handleClear">
              <el-option
                v-for="item in optPowerList"
                :key="item"
                :label="item"
                :value="item"
              />
            </el-select>
          </li>
          <li>
            <span>{{ $t('searchHome.part3') }}</span>
            <el-select v-model="formData.groupCode" placeholder="请选择" clearable @clear="handleClear">
              <el-option
                v-for="item in groupOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </li>
          <li>
            <el-button type="primary" plain @click="getSearchPart">{{ $t('common.commonConfirm') }}</el-button>
            <el-button plain @click="reset">{{ $t('table.reset') }}</el-button>
          </li>
        </ul>
      </el-tab-pane>
    </el-tabs>

    <div v-if="userName !== 'overseas'" class="searchRight">
      <span v-if="moudles.indexOf('epc:cart') !== -1" @click="goCart"><svg-icon icon-class="frame134" class="iconClass" />{{ $t('route.routeCart') }}</span>
      <span v-if="moudles.indexOf('eis:iccid') !== -1" @click="goICCID"><svg-icon icon-class="frame56" class="iconClass" /> {{ $t('route.routeIccId') }}</span>
      <span v-if="moudles.indexOf('epc:cart') !== -1" @click="goKeyQuery"><svg-icon icon-class="frame56" class="iconClass" /> {{ $t('route.routeKeyQuery') }}</span>
      <span> <lang-select class="right-menu-item hover-effect" /></span>
      <span>
        <el-dropdown
          class="avatar-container right-menu-item hover-effect"
          trigger="click"
        >
          <div class="avatar-wrapper">
            <span class="el-breadcrumb__inner" @click="getUserInfo"><svg-icon icon-class="group58" class="iconClass" />{{ name }}<i class="el-icon-arrow-down" /></span>
          </div>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item>
              <div class="avatar">
                <svg-icon icon-class="group58" class="iconClass" />
                <h5>{{ userInfoOptions.username }}</h5>
                <p>{{ userInfoOptions.enterpriseName }}</p>
              </div>
            </el-dropdown-item>
            <el-dropdown-item>
              <span class="userW"><span class="name1">用户姓名</span><span class="spanR">{{ userInfoOptions.realName }}</span></span>
            </el-dropdown-item>
            <el-dropdown-item>
              <span class="userW"><span class="name1">手机号</span><span class="spanR">{{ userInfoOptions.phone }}</span></span>
            </el-dropdown-item>
            <el-dropdown-item>
              <span class="userW"><span class="name1">邮箱</span><span class="spanR">{{ userInfoOptions.email }}</span></span>
            </el-dropdown-item>
            <el-dropdown-item>
              <div class="gangwei">
                <h5><svg-icon icon-class="frame7" class="iconClass" />岗位</h5>
                <p v-for="i in userInfoOptions.sysPositionList" :key="i.id">
                  <span>{{ i.name }}</span>
                </p>
              </div>
            </el-dropdown-item>
            <el-dropdown-item>
              <span class="logOut"><el-button type="text" @click="throttle()">同步信息</el-button></span>
            </el-dropdown-item>
            <el-dropdown-item @click.native="logout">
              <span class="logOut">{{ $t('login.logOut') }}</span>
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </span>
    </div>
    <div v-if="userName === 'overseas'" class="searchMain">
      <el-form ref="formInline" :inline="true" :rules="rules" :model="formInline" class="demo-form-inline">
        <el-form-item :label="$t('routeSearchParts.searchParts15')" prop="model">
          <el-select v-model="formInline.model" clearable :placeholder="$t('searchHome.tips')" @focus="getInternetVehicle">
            <el-option
              v-for="item in modelList"
              :key="item"
              :label="item"
              :value="item"
            />
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('routeSearchParts.searchParts21')" prop="typeApprovalNumber">
          <el-select v-model="formInline.typeApprovalNumber" clearable :placeholder="$t('searchHome.tips')" @focus="getInternetVehicle">
            <el-option
              v-for="item in typeApprovalNumberList"
              :key="item"
              :label="item"
              :value="item"
            />
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('routeSearchParts.searchParts22')" prop="variant">
          <el-select v-model="formInline.variant" clearable :placeholder="$t('searchHome.tips')" @focus="getInternetVehicle">
            <el-option
              v-for="item in variantList"
              :key="item"
              :label="item"
              :value="item"
            />
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('routeSearchParts.searchParts23')" prop="version">
          <el-select v-model="formInline.version" clearable :placeholder="$t('searchHome.tips')" @focus="getInternetVehicle">
            <el-option
              v-for="item in versionList"
              :key="item"
              :label="item"
              :value="item"
            />
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button plain type="primary" @click="getOverseasVehicle">{{ $t('common.commonConfirm') }}</el-button>
          <el-button plain @click="reset">{{ $t('table.reset') }}</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div v-if="userName === 'overseas'" class="searchRight">
      <span> <lang-select class="right-menu-item hover-effect" /></span>
      <el-dropdown-item class="overseas" @click.native="logout">
        <span>{{ $t('login.logOut') }}</span>
      </el-dropdown-item>
    </div>
  </div>
</template>
<script>
import LangSelect from '@/components/LangSelect'
import { setWaterMark } from '@/api/watermark'
import Cookies from 'js-cookie'
import { mapGetters } from 'vuex'
import sysModelApi from '@/api/epc/sysModel-api'
import getCodeApi from '@/api/sso/getCode-api'
import getVinApi from '@/api/epc/getVin-api'
import { copy } from "@/utils/copy.js";
  export default {
     components: {
       LangSelect
     },
     inject: ['reload'],
    data() {
      return {
        activeName: 'first',
        userName: this.$store.getters.name,
        baseURL: process.env.VUE_APP_BASE_URL,
        userInfoOptions: [],
        restaurants: [],
        queryHistory: [],
        moudles: [],
        dialogVisiblePart: false,
        circleUrl: "https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png",
        jwtHeader: { token: Cookies.get('Admin-Token') },
        formInline: {
          typeApprovalNumber: '',
          variant: '',
          model: '',
          version: ''
        },
        form: {
          vin: '',
          part1: '',
          part2: '',
          vehSeries: '',
          vehYearModel: '',
          optPower: ''
        },
        listQuery: {
         vehSeries: '',
         optPower: '',
         vehYearModel: null,
         optRange: null,
         optPkg: '',
         batteryCore: ''
        },
        formData: {
          vehSeries: '',
          optPower: '',
          vehYearModel: null,
          partName: '',
          partCode: '',
          groupCode: '',
          pageSorts: [],
          pageIndex: 1,
          pageSize: 50
        },
        rules: {
           model: [
            { required: true, message: this.$t('message.selectVehicleType'), trigger: 'change' } // 请选择车型
          ],
           typeApprovalNumber: [
            { required: true, message: this.$t('message.selectTypeApprovalNumber'), trigger: 'change' } // 请选择型式认证号
          ],
           version: [
            { required: true, message: this.$t('message.selectVersion'), trigger: 'change' } // 请选择版本,
          ],
           variant: [
            { required: true, message: this.$t('message.selectVehicleType'), trigger: 'change' } // 请选择车型
          ]
        },
        groupOptions: [
         {
            value: '10',
            label: '动力电池系统'
         }, {
            value: '20',
            label: '电机电控系统'
         }, {
            value: '30',
            label: '底盘系统'
         }, {
            value: '50',
            label: '内外饰系统'
         }, {
            value: '60',
            label: '车身系统'
         }, {
            value: '70',
            label: '增程系统'
         }, {
            value: '80',
            label: '汽车电子系统'
         }, {
            value: '90',
            label: '附件系统'
         }
        ],
        lastTime: 0,
        versionList: [],
        variantList: [],
        typeApprovalNumberList: [],
        modelList: [],
        batteryCoreList1: [],
        optPkgList1: [],
        vehSeriesList: [],
        batteryCoreList: [],
        optPkgList: [],
        optPowerList: [],
        optRangeList: [],
        vehYearModelList: []
      };
    },
     computed: {
      ...mapGetters(["sidebar", "avatar", "device", "name", "type"])
    },
    created() {
     this.moudles = localStorage.getItem('moudles')
     this.formData.partCode = sessionStorage.getItem("partCode")
     this.formData.partName = sessionStorage.getItem("partName")
     this.formData.vehSeries = sessionStorage.getItem("vehSeries1")
     this.formData.optPower = sessionStorage.getItem("optPower1")
     this.formData.vehYearModel = sessionStorage.getItem("vehYearModel1")
     this.formData.groupCode = sessionStorage.getItem("groupCode")
     this.formData.pageIndex = sessionStorage.getItem("pageIndex")
     this.form.vin = sessionStorage.getItem("searchVin")
     this.listQuery.vehSeries = sessionStorage.getItem("vehSeries")
     this.listQuery.optPower =  sessionStorage.getItem("optPower")
     this.listQuery.vehYearModel = sessionStorage.getItem("vehYearModel")
     this.listQuery.optRange = sessionStorage.getItem("optRange")
     this.listQuery.optPkg = sessionStorage.getItem("optPkg")
     this.listQuery.batteryCore  = sessionStorage.getItem("batteryCore")
     if (this.listQuery.vehSeries && this.listQuery.vehYearModel && this.listQuery.optPower) {
        this.activeName = 'third'
      } else {
        this.listQuery.vehSeries = ''
      }
     if ((this.formData.partCode || this.formData.partName) && !this.listQuery.vehSeries) {
       this.activeName = 'second'
       this.formData.pageIndex = 1
       console.log(this.formData);
     }
    },
    mounted() {
      setWaterMark('', this.userName)
      //  this.getVin()
      this.readCookie('queryHistory')
      this.getPlaceholder()
    },
    methods: {
      getPlaceholder() {
        return this.restaurants.length > 0 ? '请选择' : '暂无历史查询记录'
      },
      handleClick(tab) {
        if (tab.name === 'second') {
           sessionStorage.clear()
           this.listQuery.vehSeries = ''
          this.listQuery.optPower = ''
          this.listQuery.vehYearModel = null
          this.listQuery.optRange = null
          this.listQuery.optPkg = ''
          this.listQuery.batteryCore = ''
           this.getCar()
           this.$router.push({ path: '/repairMaterial/searchParts' })
        }
        // if (tab.name === 'first') {
        //    this.$router.push({ path: '../vehicle/vehicleInfo' })
        // }
        //  if (tab.name === 'third') {
        //    this.$router.push({ path: '../repairMaterial/modelNavigation' })
        //   //  this.$router.push({ path: '../vehicle/vehicleInfo' })
        // }
      },
      goCart() {
        this.$router.push({ path: '/epc/cart' })
      },
      getUserInfo() {
         getCodeApi.getCurUserInfo(this.name).then(response => {
            this.userInfoOptions = response.data
         })
      },
      getSyncCepUserInfo() {
         getCodeApi.getsyncCepUserInfo(this.name).then(response => {
           if (response.code === 200) {
                this.$message({
                  message: this.$t('message.syncSuccess'), // 同步成功
                  type: 'success'
                })
            }
            this.getUserInfo()
         })
      },
      handleClear() {
        sessionStorage.removeItem("partCode");
        sessionStorage.removeItem("partName");
        sessionStorage.removeItem("groupCode");
        sessionStorage.removeItem("vehSeries1");
        sessionStorage.removeItem("optPower1");
        sessionStorage.removeItem("vehYearModel1");
      },
      // getVin() {
      //   getVinApi.getHistoryVinList().then(response => {
      //      this.restaurants = response.data
      //    })
      // },
      getSearchPart() {
        this.dialogVisiblePart = false
        if (this.formData.partCode) {
           this.formData.partCode = this.formData.partCode.split(' ').join('');
        }
        if (this.formData.partName || this.formData.partCode) {
          this.$router.push({
              path: '/repairMaterial/searchParts',
              query: { data: JSON.stringify(this.formData) }
          })
          if (this.formData.partCode) {
           sessionStorage.setItem("partCode", this.formData.partCode)
           sessionStorage.setItem("pageIndex", this.formData.pageIndex)
           this.formData.partCode = sessionStorage.getItem("partCode")
           this.formData.pageIndex = sessionStorage.getItem("pageIndex")
          }
          if (this.formData.partName) {
           sessionStorage.setItem("partName", this.formData.partName)
           sessionStorage.setItem("pageIndex", this.formData.pageIndex)
           this.formData.partName = sessionStorage.getItem("partName")
           this.formData.pageIndex = sessionStorage.getItem("pageIndex")
          }
          if (this.formData.vehSeries) {
            sessionStorage.setItem("vehSeries1", this.formData.vehSeries)
            this.formData.vehSeries = sessionStorage.getItem("vehSeries1")
          }
          if (this.formData.optPower) {
            sessionStorage.setItem("optPower1", this.formData.optPower)
            this.formData.optPower = sessionStorage.getItem("optPower1")
          }
          if (this.formData.vehYearModel) {
            sessionStorage.setItem("vehYearModel1", this.formData.vehYearModel)
            this.formData.vehYearModel = sessionStorage.getItem("vehYearModel1")
          }
          if (this.formData.groupCode) {
           sessionStorage.setItem("groupCode", this.formData.groupCode)
           this.formData.groupCode = sessionStorage.getItem("groupCode")
          }
          this.form.vin = ''
          sessionStorage.removeItem("searchVin");
          sessionStorage.removeItem("vehSeries");
          sessionStorage.removeItem("optPower");
          sessionStorage.removeItem("vehYearModel");
          sessionStorage.removeItem("optRange");
          sessionStorage.removeItem("optPkg");
          sessionStorage.removeItem("batteryCore");
          this.listQuery.vehSeries = ''
          this.listQuery.optPower = ''
          this.listQuery.vehYearModel = null
          this.listQuery.optRange = null
          this.listQuery.optPkg = ''
          this.listQuery.batteryCore = ''
          this.dialogVisiblePart = false
          this.reload()
          this.$forceUpdate()
        } else {
           this.$message({
            type: 'error',
            message: this.$t('message.selectPartDrawingOrPartName'), // 请输入配件图号或配件名称
            showClose: true,
            duration: 2 * 1000
           })
        }
      },
      getVehicle() {
        this.form.vin = this.form.vin.replace(/\s/g, '')
         if (
            this.form.vin !== '' && this.form.vin.length === 17
          ) {
            this.$router.push({
                path: '/vehicle/vehicleInfo',
                query: { vin: this.form.vin }
            })
          sessionStorage.setItem("searchVin", this.form.vin)
          this.form.vin = sessionStorage.getItem("searchVin")
          sessionStorage.removeItem("epcVin");
          sessionStorage.removeItem("partCode");
          sessionStorage.removeItem("partName");
          sessionStorage.removeItem("groupCode");
          sessionStorage.removeItem("vehSeries1");
          sessionStorage.removeItem("optPower1");
          sessionStorage.removeItem("vehYearModel1");
          this.formData.partCode = ''
          this.formData.partName = ''
          this.formData.vehSeries = ''
          this.formData.optPower = ''
          this.formData.vehYearModel =  null
          this.formData.groupCode = ''
          sessionStorage.removeItem("vehSeries");
          sessionStorage.removeItem("optPower");
          sessionStorage.removeItem("vehYearModel");
          sessionStorage.removeItem("optRange");
          sessionStorage.removeItem("optPkg");
          sessionStorage.removeItem("batteryCore");
          this.listQuery.vehSeries = ''
          this.listQuery.optPower = ''
          this.listQuery.vehYearModel = null
          this.listQuery.optRange = null
          this.listQuery.optPkg = ''
          this.listQuery.batteryCore = ''
          console.log(this.form.vin);
          this.reload()
          this.$set(this.form, 'vin', this.form.vin)
          this.$forceUpdate()
          // this.queryHistory.push(this.form.vin)
          this.queryHistory.unshift(this.form.vin)
          this.updateCookie('queryHistory', this.queryHistory)
       } else {
         this.$message({
            type: 'error',
            message: this.$t('searchHome.tips3'), // 请输入17位VIN码
            showClose: true,
            duration: 2 * 1000
         })
       }
      },
      updateCookie(name, value) {
        // 将数组转换为JSON字符串，并存储到Cookie中
        localStorage.setItem(name, JSON.stringify(value), { expires: 7 })
      },
      readCookie(name) {
      // 读取查询历史
        const cookieValue = localStorage.getItem(name)
        if (cookieValue) {
          this.queryHistory = JSON.parse(cookieValue)
          this.restaurants = [...new Set(this.queryHistory)]
          if (this.restaurants.length > 10) {
            this.restaurants.pop()
          }
        }
        console.log(this.restaurants)
      },
      getMore() {
        this.dialogVisiblePart = true
        // sessionStorage.removeItem("vehSeries");
        // sessionStorage.removeItem("vehYearModel");
        // sessionStorage.removeItem("optPkg");
      },
      getCar() {
        if (this.type === "海外用户") {
          sysModelApi.getTreeListOversea(this.formData)
            .then(response => {
              this.modelOptions = response.data
              if (this.modelOptions) {
                this.vehSeriesList = this.modelOptions.vehSeriesList
                this.optPkgList = this.modelOptions.optPkgList
                this.vehYearModelList = this.modelOptions.vehYearModelList
              }
            })
        } else {
          sysModelApi
            .getTreeList(this.formData)
            .then(response => {
              this.modelOptions = response.data
              if (this.modelOptions) {
                this.vehSeriesList = this.modelOptions.vehSeriesList
                this.optPkgList = this.modelOptions.optPkgList
                this.vehYearModelList = this.modelOptions.vehYearModelList
              }
            })
        }
      },
      getVehicleMaterial() {
        console.log(this.listQuery);
        if (!this.listQuery.vehSeries) {
          this.$message({
                type: 'error',
                message: this.$t('message.selectVehicleType'), // 请选择车型
                showClose: true,
                duration: 2 * 1000
            })
        } else if (!this.listQuery.vehYearModel) {
          this.$message({
                type: 'error',
                message: this.$t('message.selectVehYearModel'), // 请选择年款
                showClose: true,
                duration: 2 * 1000
            })
        } else if (!this.listQuery.optRange) {
          this.$message({
                type: 'error',
                message: this.$t('message.selectOptRange'), // 请选择里程
                showClose: true,
                duration: 2 * 1000
            })
        } else if (!this.listQuery.optPower) {
          this.$message({
                type: 'error',
                message: this.$t('message.selectOptPower'), // 请选择配置
                showClose: true,
                duration: 2 * 1000
            })
        } else if (!this.listQuery.batteryCore) {
          this.$message({
                type: 'error',
                message: this.$t('message.selectBatteryCore'), // 请选择电池类型
                showClose: true,
                duration: 2 * 1000
            })
        } else {
           this.$router.push({
            name: 'ModelNavigation',
            // name: 'VehicleInfo',
            query: { data: this.listQuery }
            })
            sessionStorage.setItem("vehSeries", this.listQuery.vehSeries)
            this.listQuery.vehSeries = sessionStorage.getItem("vehSeries")
            sessionStorage.setItem("optPower", this.listQuery.optPower)
            this.listQuery.optPower = sessionStorage.getItem("optPower")
            sessionStorage.setItem("vehYearModel", this.listQuery.vehYearModel)
            this.listQuery.vehYearModel = sessionStorage.getItem("vehYearModel")
            sessionStorage.setItem("optRange", this.listQuery.optRange)
            this.listQuery.optRange = sessionStorage.getItem("optRange")
            if (this.listQuery.optPkg) {
              sessionStorage.setItem("optPkg", this.listQuery.optPkg)
              this.listQuery.optPkg = sessionStorage.getItem("optPkg")
            } else {
              sessionStorage.setItem("optPkg", '')
              this.listQuery.optPkg = sessionStorage.getItem("optPkg")
            }
            sessionStorage.setItem("batteryCore", this.listQuery.batteryCore)
            this.listQuery.batteryCore = sessionStorage.getItem("batteryCore")
            sessionStorage.removeItem("searchVin");
            this.form.vin = ''
            sessionStorage.removeItem("partCode");
            sessionStorage.removeItem("partName");
            sessionStorage.removeItem("groupCode");
            sessionStorage.removeItem("vehSeries1");
            sessionStorage.removeItem("optPower1");
            sessionStorage.removeItem("vehYearModel1");
            this.formData.partCode = ''
            this.formData.partName = ''
            this.formData.vehSeries = ''
            this.formData.optPower = ''
            this.formData.vehYearModel =  null
            this.formData.groupCode = ''
            this.reload()
            this.activeName === 'third'
          }
      },
      getOverseasVehicle() {
        if (!this.formInline.model) {
          this.$message({
                type: 'error',
                message: this.$t('message.selectVehicleType'), // 请选择车型
                showClose: true,
                duration: 2 * 1000
            })
        } else if (!this.formInline.typeApprovalNumber) {
          this.$message({
                type: 'error',
                message: this.$t('message.selectTypeApprovalNumber'), // 请选择型式认证号
                showClose: true,
                duration: 2 * 1000
            })
        } else if (!this.formInline.variant) {
          this.$message({
                type: 'error',
                message: this.$t('message.selectType'), // 请选择款型
                showClose: true,
                duration: 2 * 1000
            })
        } else if (!this.formInline.version) {
          this.$message({
                type: 'error',
                message: this.$t('message.selectVersion'), // 请选择版本
                showClose: true,
                duration: 2 * 1000
            })
        } else {
           this.$router.push({
            // name: 'ModelNavigation',
            path: '/repairMaterial/modelNavigation',
            query: { data: this.formInline }
            })
            sessionStorage.setItem("model", this.formInline.model)
            this.formInline.model = sessionStorage.getItem("model")
            sessionStorage.setItem("typeApprovalNumber", this.formInline.typeApprovalNumber)
            this.formInline.typeApprovalNumber = sessionStorage.getItem("typeApprovalNumber")
            sessionStorage.setItem("variant", this.formInline.variant)
            this.formInline.variant = sessionStorage.getItem("variant")
            sessionStorage.setItem("version", this.formInline.version)
            this.formInline.version = sessionStorage.getItem("version")
            this.activeName === 'third'
          }
      },
      handleChange() {
        sessionStorage.clear()
        this.listQuery.vehSeries = this.listQuery.vehSeries
      },
      goKeyQuery() {
         this.$router.push({ path: '/epc/keyQuery' })
      },
      goICCID() {
         this.$router.push({ path: '/epc/iccId' })
      },
      getfocus() {
        const listQuery1 = {
          vehSeries: this.listQuery.vehSeries,
          optPower: this.listQuery.optPower,
          vehYearModel: this.listQuery.vehYearModel,
          optRange: this.listQuery.optRange,
          optPkg: this.listQuery.optPkg,
          batteryCore: this.listQuery.batteryCore
        }
        if (this.type === "海外用户") {
          sysModelApi.getTreeListOversea(listQuery1)
            .then(response => {
              this.modelOptions = response.data
              if (this.modelOptions) {
                this.vehSeriesList = this.modelOptions.vehSeriesList
                this.batteryCoreList = this.modelOptions.batteryCoreList
                this.optPkgList = this.modelOptions.optPkgList
                this.optPowerList = this.modelOptions.optPowerList
                this.optRangeList = this.modelOptions.optRangeList
                this.vehYearModelList = this.modelOptions.vehYearModelList
                if (this.batteryCoreList) {
                  this.batteryCoreList1 = this.batteryCoreList.filter(function(s) {
                  return s && s.trim();
                })
                }
                if (this.optPkgList1) {
                  this.optPkgList1 = this.optPkgList.filter(function(s) {
                    return s && s.trim();
                  })
                }
              }
            })
        } else {
          sysModelApi
            .getTreeList(listQuery1)
            .then(response => {
              this.modelOptions = response.data
              if (this.modelOptions) {
                this.vehSeriesList = this.modelOptions.vehSeriesList
                this.batteryCoreList = this.modelOptions.batteryCoreList
                this.optPkgList = this.modelOptions.optPkgList
                this.optPowerList = this.modelOptions.optPowerList
                this.optRangeList = this.modelOptions.optRangeList
                this.vehYearModelList = this.modelOptions.vehYearModelList
                if (this.batteryCoreList) {
                  this.batteryCoreList1 = this.batteryCoreList.filter(function(s) {
                  return s && s.trim();
                })
                }
                if (this.optPkgList1) {
                  this.optPkgList1 = this.optPkgList.filter(function(s) {
                    return s && s.trim();
                  })
                }
              }
            })
        }
      },
      handleVinChange(query) {
        console.log(query);
        this.form.vin = query
        if (query.length >= 8) {
           getVinApi.getVinList(query).then(response => {
            this.restaurants = response.data
          })
        } else {
          this.restaurants = [];
        }
      },
      onFocus() {
        if (!this.form.vin) {
          this.readCookie('queryHistory')
        }
      },
      throttle() {
          // 获取当前时间的时间戳
          const now = new Date().valueOf();
          // 第一次点击
          if (this.lastTime === 0) {
          console.log('触发事件');
          this.getSyncCepUserInfo()
          this.lastTime = now;
          } else {
            if ((now - this.lastTime) > 1000 * 60 * 5) {
              // 重置上一次点击时间，间隔时间
              this.lastTime = now;
              this.getSyncCepUserInfo()
              console.log('间隔时间，触发方法');
              // 添加自己要调用的方法
            } else {
              console.log('不触发');
               this.$message({
                type: 'warning',
                message: this.$t('message.noSyncAgainFor5Minutes'), // 5分钟内不能再次同步
                showClose: true,
                duration: 3 * 1000
             })
            }
          }
      },
      getInternetVehicle() {
        const listQuery2 = {
          model: this.formInline.model,
          typeApprovalNumber: this.formInline.typeApprovalNumber,
          variant: this.formInline.variant,
          version: this.formInline.version
        }
         sysModelApi
            .getInternetTreeList(listQuery2)
            .then(response => {
              this.modelOptions = response.data
              if (this.modelOptions) {
                this.modelList = this.modelOptions.modelList
                this.typeApprovalNumberList = this.modelOptions.typeApprovalNumberList
                this.variantList = this.modelOptions.variantList
                this.versionList = this.modelOptions.versionList
              }
            })
      },
      copy,
      // handleInput(value) {
      //   this.form.vin = value.replace(/\s/g, '')
      //   console.log(this.form.vin)
      //   // LFZ71AJ44ND040575
      // },
      reset() {
        this.formInline.model = ''
        this.formInline.typeApprovalNumber = ''
        this.formInline.variant = ''
        this.formInline.version = ''
        this.listQuery.vehSeries = ''
        this.listQuery.optPower = ''
        this.listQuery.vehYearModel = null
        this.listQuery.optRange = null
        this.listQuery.optPkg = ''
        this.listQuery.batteryCore = ''
        sessionStorage.clear()
        this.form.vin = ''
        this.formData.vehSeries = ''
          this.formData.optPower = ''
          this.formData.vehYearModel =  null
          this.formData.groupCode = ''
          this.formData.partCode = ''
          this.formData.partName = ''
      },
       async logout() {
        await this.$store.dispatch("user/logout");
        // this.$router.push(`/login?redirect=${this.$route.fullPath}`);
        window.location.href = this.baseURL + "/#/usrLogin";
        // window.location.href = window.close();
      }
    }
  };
</script>

<style lang="scss" scoped>
.search{
  margin: 5px 0;
  .searchMain{
    width: 99%;
    text-align: center;
    margin: 34px auto 0px;
    position: relative;
    ul{
      display:flex;
      justify-content:center;
      align-items:center;
      li{
        float: left;
        margin: 0 11px 3px 0;
        font-size: 12px;
        span{
          b{
            color: red;
            font-size: 12px;
            position: absolute;
            margin-left: -7px;
            top: 7px;
          }
        }
      }
    }
    .el-icon-search{
      position: absolute;
      padding-left: 8px;
      top: 4px;
      z-index: 100;
      color: #999;
    }

    .el-input{
      width: 120px;
    }
     .vinInputW{
      width: 60% !important;
    }
  }
  .searchRight{
    position: absolute;
    right: 10px;
    top: 6px;
    span{
      font-size: 12px;
      padding: 0 15px;
      color: #333;
      cursor: pointer;
      .iconClass{
        padding-right: 5px;
        font-size: 18px;
        color: #333;
        padding-top: 3px;
      }
    }
    .overseas{
      height: 20px;
      line-height: 20px;
      float: right;
      padding: 0;
    }
  }
}
</style>
